import router, { isMobile, routes_pc, routes_phone } from '@/router'

router.addRoute(isMobile() ? routes_phone[0] : routes_pc[0])
